// extracted by mini-css-extract-plugin
module.exports = {"searchLabel":"PartnerSection_searchLabel__y8cTM"};